import {Injectable} from '@angular/core';
import {HttpAuthService} from '@shared/service/http-auth.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {MessageManagerUtilities} from '@shared/service/message-manager/message-manager-utilities';
import {MessageDetail} from '@shared/service/message-manager/message.model';
import {Observable, throwError} from 'rxjs';
import {CommodityModel} from '@shared/models/commodity.model';
import {catchError, map, tap} from 'rxjs/operators';
import {MessageManagerService} from '@shared/service/message-manager/message-manager.service';
import {Response} from '@angular/http';
import { PermissionService } from './permission.service';
import { ProfilePermissionModel, UserPermissionsModel } from '../models/user-permission.model';
import { SelectCommoditiesService } from './select-commodities.service';
import { Utilities as U } from '../utilities/utilities.model';
import { logger } from '../utilities/logger.model';

@Injectable({
	providedIn: 'root'
})
export class CommoditiesService {

	environment: AppConfigEnvironment;
	userPermission: UserPermissionsModel;

	constructor(
		private httpAuthService: HttpAuthService,
		private appConfig: AppConfigEnvironmentService,
		private messageManagerService: MessageManagerService,
		private permissionService: PermissionService,

		// servizio duplicato, andrebbe mergiato con questo
		private selectCommoditiesService: SelectCommoditiesService,
	) {
		this.environment = appConfig.Environment;
		this.userPermission = this.permissionService.getCurrentUserPermissions();
	}

	getAllCenter(idCommodity: string, onSuccess: (dealer: any) => void, onFailure: (message: MessageDetail) => void): void {
		const url: string = this.environment.PERMISSION_API + '/commodities/' + idCommodity;
		this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).subscribe(
			response => {
				const returnArray: any = (response.json());
				if (response.status === 200) {
					try {
						onSuccess(returnArray);
					} catch (error) {
						onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(returnArray));
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(returnArray));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			});
		// }
	}


	getAll(dossierId: string, workingId: string, quotationId: string, onSuccess: (dealer: any) => void, onFailure: (message: MessageDetail) => void): void {
		const url: string = this.environment.AUTHORITY + '/dossiers/' + dossierId + '/workings/' + workingId + '/quotations/' + quotationId + '/dealers';
		this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).subscribe(
			response => {
				const returnArray: any = (response.json());
				if (response.status === 200) {
					try {
						onSuccess(returnArray);
					} catch (error) {
						onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			});
		// }
	}

	getCommodityById(commodityId: string): Observable<CommodityModel> {
		const url: string = this.environment.PERMISSION_API + '/commodities/' + commodityId;
		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json()),
			catchError((error: Response) => {
				this.messageManagerService.pushInnerMessage(MessageManagerUtilities.getMessageDetailsFromResponse(error));
				return throwError(error);
			}));
	}

	getCommodityByCurrentProfile(): CommodityModel[] {
		return this.userPermission.getCurrentProfile().commodities;
	}
	
	/**
	 * Recupera le commodities di un profilo con meccanismo di fallback.
	 * 
	 * (Solo per i profili centro) verifica che abbiano effettivamente le commodities,
	 * altrimenti le recupera dalla lista completa dei profili (fix per bug noto).
	 * 
	 * @param {ProfilePermissionModel} profile - Profilo da cui recuperare le commodities (default: profilo corrente)
	 * @returns {CommodityModel[]} Lista delle commodities del profilo
	 * @TODO: da capire quando e come i profili centro perdono le commodities
	 **/ 
	getCommodityList(profile?: ProfilePermissionModel): CommodityModel[] {
		if (!profile) {
			profile = this.userPermission.getCurrentProfile();
		}

		let commodityList = profile.commodities;

		// Applica fix per profili centro che perdono le commodities
		if (U.isEmpty(commodityList) && profile.isCenter()) {
			this.restoreCommoditiesForCenterProfile(profile);
			commodityList = profile.commodities;
		}

		return commodityList;
	}

	/**
	 * Ripristina le commodities mancanti nei profili centro recuperandole dalla lista master.
	 * 
	 * @param {ProfilePermissionModel} profile - Profilo centro con commodities mancanti
	 */
	private restoreCommoditiesForCenterProfile(profile: ProfilePermissionModel): void {
		// recupera le commodities del profilo dalla lista con tutti i profili
		const profileFromList = this.userPermission.all_profile.find(x => x.id === profile.id);
		const commoditiesFromList = profileFromList ? profileFromList.commodities : [];

		// salva di nuovo le commodities nel profilo corrente
		if (!U.isEmpty(commoditiesFromList)) {
			profile.setCommodities(commoditiesFromList);
		}
	}

	
	/**
	 * Raggruppa le commodities associate ad un centro (quindi filtra i duplicati), 
	 * solitamente serve per i profili NON CENTRO, 
	 * che vedono i vari centri come unica entità
	 * 
	 * @param {CommodityModel[]} commodities
	 * @returns {CommodityModel[]}
	 */
	clusteringCommodities(list: CommodityModel[]): CommodityModel[] {

		return this.selectCommoditiesService.clusteringCommodities(list);
	}
}
